import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import TreeRemovalPage from "@/pages/TreeRemovalPage";
import TucsonPage from "@/pages/service-areas/TucsonPage";
import OroValleyPage from "@/pages/service-areas/OroValleyPage";
import CatalinaPage from "@/pages/service-areas/CatalinaPage";
import SahuaritaPage from "@/pages/service-areas/SahuaritaPage";
import SaddleBrookePage from "@/pages/service-areas/SaddleBrookePage";
import OraclePage from "@/pages/service-areas/OraclePage";
import NeighborhoodPage from "@/components/NeighborhoodPage";
import neighborhoodPages from "@/data/neighborhoodPages";
import BlogStumpGrindingCost from "@/pages/BlogStumpGrindingCost";
import NotFoundPage from "@/pages/NotFoundPage";

// Strip trailing slashes to prevent duplicate URL issues in Google Search Console
const TrailingSlashRedirect = () => {
  const location = useLocation();
  if (location.pathname !== "/" && location.pathname.endsWith("/")) {
    return <Navigate to={location.pathname.slice(0, -1) + location.search + location.hash} replace />;
  }
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <TrailingSlashRedirect />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/tree-removal" element={<TreeRemovalPage />} />
          <Route path="/tucson-stump-grinding" element={<TucsonPage />} />
          <Route path="/oro-valley-stump-grinding" element={<OroValleyPage />} />
          <Route path="/catalina-stump-grinding" element={<CatalinaPage />} />
          <Route path="/sahuarita-stump-grinding" element={<SahuaritaPage />} />
          <Route path="/saddlebrooke-stump-grinding" element={<SaddleBrookePage />} />
          <Route path="/oracle-stump-grinding" element={<OraclePage />} />
          <Route path="/blog/stump-grinding-cost-tucson" element={<BlogStumpGrindingCost />} />
          {neighborhoodPages.map((page) => (
            <Route key={page.slug} path={"/" + page.slug} element={<NeighborhoodPage slug={page.slug} />} />
          ))}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
